
namespace TabAurous.SalesOrder{

    @Serenity.Decorators.registerClass()
    export class SalesOrderLaborGrid extends Serenity.EntityGrid<SalesOrderLaborRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrderLabor'; }
        protected getIdProperty() { return SalesOrderLaborRow.idProperty; }
        protected getInsertPermission() { return SalesOrderLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesOrderLaborRow.localTextPrefix; }
        protected getService() { return SalesOrderLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}